<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import { getWxJson } from '@/api/common';
// import wx from 'weixin-js-sdk';
export default {
  name: 'App',
  methods: {
    // getWConfig() {
    //   const url = window.location.href.split('#')[0]
    //   getWxJson({ url }).then((res) => {
    //     if (res.errcode === 0) {
    //       localStorage.setItem('wxConfig', JSON.stringify(res.data))
    //       this.setWxConfig(res.data)
    //     } else {
    //       console.log('获取微信sdk参数失败', res)
    //     }
    //   })
    // },
    // setWxConfig(config) {
    //   const { timestamp, nonceStr, signature, appId, jsApiList } = config
    //   wx.config({
    //     appId,
    //     timestamp,
    //     nonceStr,
    //     signature,
    //     jsApiList
    //   });
    //   wx.error((err) => {
    //     console.log(err, 'js-sdk获取失败')
    //   })
    // }
  }
}
</script>

<style lang="less" scoped>
  #app { background-color: #ebedf0;
    /deep/ p { margin: 0; }
    /deep/ .van-divider { margin: 0; }
    /deep/ .border-top { position: relative;
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        right: 0;
        top: 0;
        bottom: 0;
        border-top: 1px solid var(--borderColor, #ebedf0);
        transform: scaleY(0.5);
      }
    }
    /deep/ .border-bottom { position: relative;
      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        right: 0;
        bottom: 0;
        border-top: 1px solid var(--borderColor, #ebedf0);
        transform: scaleY(0.5);
        z-index: 100;
      }
    }
    /deep/ .border-right { position: relative;
      &::after {
        content: '';
        position: absolute;
        width: 1px;
        height: 100%;
        right: 0;
        bottom: 0;
        border-right: 1px solid var(--borderColor, #ebedf0);
        transform: scaleX(0.5);
      }
    }
  }
</style>